import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated, getToken, getUser, logout } from '../utils/auth';
import { checkLogin } from '../api/authApi';

const ProtectedRoute = ({ children, requireRole }) => {
  const [isValidating, setIsValidating] = useState(true);
  const [isValid, setIsValid] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const validateToken = async () => {
      if (!isAuthenticated()) {
        setIsValidating(false);
        setIsValid(false);
        return;
      }

      try {
        const token = getToken();
        await checkLogin(token);
        setIsValid(true);
      } catch (error) {
        console.error('Token validation failed:', error);
        // Token is invalid, logout user
        logout();
        setIsValid(false);
      } finally {
        setIsValidating(false);
      }
    };

    validateToken();
  }, []);

  if (isValidating) {
    return (
      <div className="auth-loading" role="status">
        <span className="auth-loading__spinner" />
        <span>Opening your workspace…</span>
      </div>
    );
  }

  if (!isValid) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (requireRole && getUser()?.role !== requireRole) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
